var Env;
(function(Env) {
    Env["Test"] = "test";
    Env["Development"] = "development";
    Env["Staging"] = "staging";
    Env["Sandbox"] = "sandbox";
    Env["Production"] = "production";
})(Env || (Env = {}));
function getEnv() {
    var _process_env_ENV;
    return (_process_env_ENV = process.env.ENV) !== null && _process_env_ENV !== void 0 ? _process_env_ENV : Env.Development;
}
function isDev() {
    return getEnv() === Env.Development;
}

export { Env, getEnv, isDev };
